import { createContext } from 'react';

const UserContext = createContext({
    loggedIn: false,
    jti: null,
    rsvpMap: {}
});

export default UserContext;